/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertyid2Inputs */

const en_entity_custompropertyid2 = /** @type {(inputs: Entity_Custompropertyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property ID`)
};

const de_entity_custompropertyid2 = /** @type {(inputs: Entity_Custompropertyid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property ID`)
};

/**
* | output |
* | --- |
* | "Custom Property ID" |
*
* @param {Entity_Custompropertyid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertyid2 = /** @type {((inputs?: Entity_Custompropertyid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertyid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertyid2(inputs)
	return de_entity_custompropertyid2(inputs)
});
export { entity_custompropertyid2 as "entity_customPropertyId" }